const PREFIX = 'sitt-tour';

export type TourStorageStatus = 'completed' | 'skipped';

export function hasSeenTour(key: string): boolean {
    return localStorage.getItem(`${PREFIX}:${key}`) !== null;
}

export function markTourSeen(key: string, status: TourStorageStatus): void {
    localStorage.setItem(`${PREFIX}:${key}`, status);
}
